<template>
  <div>
    <div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Training</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">{{ this.$route.query.rewatch ? 'Completed Training' : 'Assigned Training' }}</li>
        </ol>
      </nav>

      <div class="mt-4">
        <div class="row">
          <div class="col-md-12">
            <div class="card shadow p-3 mb-5 bg-white rounded border-0">
              <div class="card-body">

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="text-center" style="padding:10%;" v-if="isCompleted">
                      <h5 class="text-default">
                        Your training activities are up to date.<br>
                        No additional training is currently assigned however
                        you may review completed training modules.</h5>
                    </div>
                    <div class="text-center" style="padding:10%;" v-if="!videoLoaded && !isCompleted">
                      <img src="@/assets/img/loading.svg" v-if="loading">
                      <h1 v-if="!loading && !videoLoaded" class="text-default" >Unable to load training.</h1>
                    </div>

                    <div class="videoContent" v-if="!loading && videoLoaded">

                      <video-player
                        v-if="currentTrainingType === 'video'"
                        :options="playerOptions"
                        :playsinline="true"
                        @playerEnded="playerEnded"
                      />
                      <scorm-player
                        v-else-if="currentTrainingType === 'scorm'"
                        :assignment-id="assignedUserID"
                        :module-id="trainingVideo.ID"
                        :user-id="$store.state.auth.jwtPayload.user_id"
                        :launch-path="trainingVideo.launch_path"
                        @scormCompleted="playerEnded"
                      />

                    </div>
                  </div>

                  <div class="col text-default text-center mt-3" v-if="!loading && !isCompleted">
                    <h6 style="font-size:14px;">
                      <span class="badge me-2 border align-middle" :class="isScorm(trainingVideo) ? 'bg-theme text-white' : 'bg-secondary'">
                        <i :class="isScorm(trainingVideo) ? 'fas fa-laptop-code' : 'fas fa-play-circle'"></i>
                        {{ isScorm(trainingVideo) ? (getScormVersion(trainingVideo) ? ' SCORM ' + getScormVersion(trainingVideo) : ' SCORM') : ' Video' }}
                      </span>
                      <strong>{{videoName}}</strong>
                    </h6>
                    <h6 style="font-size:14px;">Date {{$route.query.rewatch ? 'Completed' : 'Assigned'}}: <strong>{{videoAdded}}</strong></h6>
                  </div>

                </div>

                <div class="row mb-5">
                  <div class="col"></div>
                  <div class="col-lg-8 col-md-8 col-xs-8 mt-2" v-if="!loading" >
                    <carousel ref="myCarousel" :settings="settings" :modelValue="settings.currentSlide" v-model="settings.currentSlide" class="player-nav" :breakpoints="breakpoints" v-if="trainingVideos.length > 0">
                     <slide v-for="(item, index ) in trainingVideos" :key="index">
                        <div class="carousel-card-wrapper" @click="routeVideo($store.state.auth.isSuperAdmin ? item.ID : item.training_video.ID, true, item.ID)">

                          <div class="type-badge" :class="item.type === 'scorm' ? 'badge-scorm' : 'badge-video'">
                            <i :class="item.type === 'scorm' ? 'fas fa-laptop-code' : 'fas fa-play-circle'"></i>
                            {{ item.type === 'scorm' ? 'SCORM ' + item.training_video.scorm_version : 'Video' }}

                          </div>

                          <img class="carousel-image" :class="{'mobile-player-image' : vssWidth <= 699}" v-lazy="item.training_video.thumbnail" :alt="item.training_video.name" />

                          <div class="carousel-overlay">
                            <p class="carousel-title text-truncate" :title="item.training_video.name">
                              {{ item.training_video.name }}
                            </p>
                          </div>

                        </div>
                      </slide>

                      <template #addons>
                        <navigation />
                      </template>
                    </carousel>
                  </div>
                  <div class="col"></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { VueScreenSizeMixin } from 'vue-screen-size';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import VideoPlayer from "@/components/VideoPlayer.vue";
import ScormPlayer from "@/components/scorm/ScormPlayer.vue";
import 'vue3-carousel/dist/carousel.css';
import moment from 'moment';

export default {
  mixins: [VueScreenSizeMixin],

  components: {
    VideoPlayer,
    ScormPlayer,
    Carousel,
    Slide,
    Navigation,
  },

  data () {
    return {
      loading: true,
      trainingVideos :[],
      allModules: [],
      videoLoaded: false,

      currentTrainingType: 'video',

      playerOptions: {
        fluid: true,
        width: '840',
        height: '264',
        autoplay: false,
        controls: true,
        muted: false,
        language: 'en',
        sources: [{ type: "video/mp4", src:"" }],
        tracks: [],
        poster: "",
        playbackRates: [0.5, 1, 1.5, 2],
        textTrackSettings: false,
        html5: {nativeTextTracks: false},
        controlBar: {
          pictureInPictureToggle: false
        }
      },

      isCompleted: false,
      isCompletedAndRewatched: false,
      assignedUserID: 0,
      trainingVideo : {},
      latestQuizAttempt: null,

      settings: { itemsToShow: 1, snapAlign: 'center', mouseDrag: true, currentSlide: 0 ,wrapAround: true,},
      breakpoints: {
        700: { itemsToShow: 2, snapAlign: 'center' },
        958: { itemsToShow: 2.5, snapAlign: 'center' },
        1024: { itemsToShow: 3, snapAlign: 'center' },
      },

      switching: false,
      vssWidth: 3000,
    }
  },

  async mounted() {
    if (this.$store.state.auth.isSuperAdmin) return

    this.vssWidth = this.$vssWidth;
    this.organisationID = this.$helper.setOrganisationID();

    if (this.$helper.isVertexAnalyst()) {
      const organisationString = localStorage.getItem('userOrganisation');
      let analystOrg = JSON.parse(organisationString);
      this.organisationID = analystOrg.id
    }

    this.loading = true;
    await this.init();
  },

  updated() {
    this.$nextTick(() => {
      const svgTitles = document.querySelectorAll('.carousel__icon title');
      svgTitles.forEach(titleElement => titleElement.remove());

      const buttons = document.querySelectorAll('.carousel__next, .carousel__prev');
      buttons.forEach(button => button.removeAttribute('title'));
    });
  },

  methods: {
    async init() {
      await this.getTrainingVideos();

      if (this.$route.query.watch && this.trainingVideos.length != 0) {
        if ( !this.$store.state.auth.isSuperAdmin && this.$route.query.assigned )
          var isAssigned = await this.checkAssignedID(this.$route.query.assigned)

        if (!this.$store.state.auth.isSuperAdmin && !isAssigned) return;

        this.getTrainingVideo(this.$route.query.watch, this.$route.query.autoplay, this.$route.query.assigned);
      }
      else if (this.$route.query.rewatch) {
        if (this.isCompleted == true) {
          this.isCompletedAndRewatched = true
        }
        this.isCompleted = false
        this.getTrainingVideo(this.$route.query.rewatch, this.$route.query.autoplay, this.$route.query.assigned);
      }
      else if (this.trainingVideos.length != 0 && !this.$route.query.watch && !this.$route.query.rewatch) {
        var watchID = this.$store.state.auth.isSuperAdmin ? this.trainingVideos[0].ID : this.trainingVideos[0].training_video.ID;
        var assigned = this.$store.state.auth.isSuperAdmin ? "" : this.trainingVideos[0].ID;
        this.$router.replace({
            path: '/training/assigned-training',
            query: { watch: watchID, assigned: assigned, autoplay: false }
        });
      }
      else {
        this.isCompleted = true;
        this.loading = false
      }
    },

    isScorm(video) {
      if (!video) return false;
      const type = (video.type || video.Type || '').toLowerCase();
      const version = video.scorm_version || video.ScormVersion || '';
      return type === 'scorm' || version.length > 0;
    },

    getScormVersion(video) {
      if (!video) return '';
      return video.scorm_version || video.ScormVersion || '';
    },

    async getTrainingVideos() {
      if (!this.$store.state.user.organisation || !this.$store.state.auth.jwtPayload) return;

      let userID = this.$store.state.auth.jwtPayload.user_id;
      let allModules = [];
      let knownShadowIds = []; // Track EXACT shadow IDs

      let legacyPath = this.$store.state.auth.isSuperAdmin ? '/supadmin/trainings/videos' : `/trainings/users/${userID}/organisations/${this.organisationID}/videos`;

      try {
        const params = { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone };
        const legacyRes = await this.$axios.get(legacyPath, { params });
        if (legacyRes.data.success && legacyRes.data.training_videos) {
          legacyRes.data.training_videos.forEach(v => {
            allModules.push({
              ...v,
              type: 'video',
              is_legacy: true,
              from_legacy_api: true,
              is_completed: false
            });
          });
        }
      } catch (e) {
        console.error("Failed to load vertex videos", e);
      }

      // 2. ALWAYS FETCH LMS ENROLLMENTS
      if (!this.$store.state.auth.isSuperAdmin) {
        let newPath = `/trainings/users/${userID}/organisations/${this.organisationID}/dashboard`;
        try {
          const newRes = await this.$axios.get(newPath);
          if (newRes.data.success) {

            // --- PART A: PROGRAM ENROLLMENTS ---
            if (newRes.data.enrollments) {
              newRes.data.enrollments.forEach(enrollment => {
                const assignments = enrollment.module_assignments || enrollment.ModuleAssignments || [];

                assignments.forEach(assignment => {
                  const status = assignment.status || assignment.Status;
                  const mod = assignment.training_module || assignment.TrainingModule;
                  if (!mod) return;

                  const actualVideoId = mod.legacy_video_id || mod.LegacyVideoID || mod.ID || mod.id;

                  // Record the exact shadow ID linked by the backend
                  const shadowId = assignment.legacy_assignment_id || assignment.LegacyAssignmentID;
                  if (shadowId) knownShadowIds.push(shadowId);

                  const legacyVid = mod.training_video || mod.TrainingVideo || {};
                  const isDefault = mod.is_default_video || mod.IsDefaultVideo || mod.is_vertex_default || mod.IsVertexDefault || false;

                  allModules.push({
                    ID: assignment.ID || assignment.id,
                    legacy_assigned_id: shadowId, // Keep track of it so the player knows what quiz to hit
                    type: (mod.type || mod.Type || 'video').toLowerCase(),
                    CreatedAt: assignment.CreatedAt || assignment.created_at,
                    is_legacy: isDefault,
                    from_lms: true,
                    is_completed: status === 'completed',
                    training_video: {
                      ID: actualVideoId,
                      legacy_video_id: mod.legacy_video_id !== undefined ? mod.legacy_video_id : (mod.LegacyVideoID !== undefined ? mod.LegacyVideoID : null),
                      name: mod.name || mod.Name,
                      thumbnail: mod.thumbnail || mod.Thumbnail || legacyVid.thumbnail || legacyVid.Thumbnail || "",
                      url: mod.gcs_path || mod.GcsPath || legacyVid.url || legacyVid.Url,
                      scorm_version: mod.scorm_version || mod.ScormVersion,
                      launch_path: mod.launch_path || mod.LaunchPath
                    }
                  });
                });
              });
            }

            // --- PART B: STANDALONE AD-HOC ASSIGNMENTS ---
            if (newRes.data.adhoc_assignments) {
              newRes.data.adhoc_assignments.forEach(assignment => {
                const status = assignment.status || assignment.Status;
                const mod = assignment.training_module || assignment.TrainingModule;
                if (!mod) return;

                const actualVideoId = mod.legacy_video_id || mod.LegacyVideoID || mod.ID || mod.id;

                // Record the exact shadow ID
                const shadowId = assignment.legacy_assignment_id || assignment.LegacyAssignmentID;
                if (shadowId) knownShadowIds.push(shadowId);

                const legacyVid = mod.training_video || mod.TrainingVideo || {};
                const isDefault = mod.is_default_video || mod.IsDefaultVideo || mod.is_vertex_default || mod.IsVertexDefault || false;

                allModules.push({
                  ID: assignment.ID || assignment.id,
                  legacy_assigned_id: shadowId, // Keep track of it so the player knows what quiz to hit
                  type: (mod.type || mod.Type || 'video').toLowerCase(),
                  CreatedAt: assignment.CreatedAt || assignment.created_at,
                  is_legacy: isDefault,
                  from_lms: true,
                  is_completed: status === 'completed',
                  training_video: {
                    ID: actualVideoId,
                    legacy_video_id: mod.legacy_video_id !== undefined ? mod.legacy_video_id : (mod.LegacyVideoID !== undefined ? mod.LegacyVideoID : null),
                    name: mod.name || mod.Name,
                    thumbnail: mod.thumbnail || mod.Thumbnail || legacyVid.thumbnail || legacyVid.Thumbnail || "",
                    url: mod.gcs_path || mod.GcsPath || legacyVid.url || legacyVid.Url,
                    scorm_version: mod.scorm_version || mod.ScormVersion,
                    launch_path: mod.launch_path || mod.LaunchPath
                  }
                });
              });
            }

          }
        } catch (e) {
          console.error("Failed to load new dashboard programs", e);
        }
      }

      this.allModules = allModules;

      // 3. CAROUSEL FILTER: Strictly Active & Non-Duplicate
      this.trainingVideos = allModules.filter(v => {
          if (v.is_completed) return false;

          // Only hide the EXACT legacy shadow record, allowing legitimate duplicates to show
          if (v.from_legacy_api && knownShadowIds.includes(v.ID)) return false;

          return true;
      });

      return this.trainingVideos;
    },

    computedItems(videoID) {
     for (let index = 0; index < this.trainingVideos.length; index++) {
      const element = this.trainingVideos[index];
      if(element.training_video.ID == videoID && this.$route.query.assigned == element.ID)
        return index
     }
     return -1
    },

    async markInProgress() {
      if (this.$store.state.auth.isSuperAdmin) return;

      let userID = this.$store.state.auth.jwtPayload.user_id;
      try {
        await this.$axios.put(`/trainings/users/${userID}/assignments/${this.assignedUserID}/status`, {
          status: 'in_progress'
        });
      } catch (error) {
        console.warn("Silent fail: Could not mark video as in progress", error);
      }
    },

    async getTrainingVideo(id, autoplay, assigned_user_video_id) {
      this.loading = true;
      this.videoLoaded = false;
      this.assignedUserID = assigned_user_video_id;

      // Look in the master list so it can find rewatched videos!
      let selectedItem = this.allModules.find(v => v.ID == assigned_user_video_id || v.legacy_assigned_id == assigned_user_video_id);

      if (!selectedItem && this.$route.query.rewatch) {
         selectedItem = {
            type: this.$route.query.type || 'video',
            is_legacy: String(this.$route.query.is_legacy) === 'true',
            legacy_assigned_id: assigned_user_video_id,
            training_video: { ID: id }
         };
      }

      if (!selectedItem) {
         this.$toast.error("Training module not found.");
         this.loading = false;
         return;
      }

      this.currentTrainingType = selectedItem.type || 'video';
      this.trainingVideo = selectedItem.training_video;

      this.settings.currentSlide = this.computedItems(this.trainingVideo.ID);
      if(this.settings.currentSlide == -1) this.settings.currentSlide = 0;

      if (this.currentTrainingType === 'scorm') {
        this.videoLoaded = true;
        this.loading = false;
        return;
      }

      const videoFetchId = this.trainingVideo.ID;
      const assignmentFetchId = selectedItem.legacy_assigned_id || assigned_user_video_id;

      if (selectedItem.is_legacy) {
        this.playerOptions.tracks = null;
        await this.getCaptionsByVideoID(videoFetchId);
        await this.$axios.get(`/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/videos/${videoFetchId}`)
        .then((response) => {
          if (response.data.success && response.data.training_video){
            this.trainingVideo = response.data.training_video;
            this.playerOptions.autoplay = this.stringToBoolean(autoplay);
            this.playerOptions.sources[0].src = response.data.training_video.url;
            this.playerOptions.poster = response.data.training_video.thumbnail;

            this.videoLoaded = true;
            this.loading = false;

            this.saveQuizAttempt(assignmentFetchId);
          } else {
            this.$toast.error(response.data.message)
          }
        }).catch()
      } else {
        this.playerOptions.tracks = null;
        await this.getCaptionsByVideoID(id);

        this.playerOptions.autoplay = this.stringToBoolean(autoplay);
        this.playerOptions.sources[0].src = this.trainingVideo.url || this.trainingVideo.GcsPath;
        this.playerOptions.poster = this.trainingVideo.thumbnail || this.trainingVideo.Thumbnail;

        this.videoLoaded = true;
        this.loading = false;

        this.markInProgress();
      }
    },

    async saveQuizAttempt(legacy_assignment_id) {
      if (!this.$store.state.user.organisation) return;
      if (this.$store.state.auth.isSuperAdmin) return;

      const selectedItem = this.allModules.find(v => v.ID == this.assignedUserID || v.legacy_assigned_id == this.assignedUserID);

      let isLegacy = false;
      if (selectedItem) {
         const hasLegacyId = selectedItem.training_video && selectedItem.training_video.legacy_video_id !== null && selectedItem.training_video.legacy_video_id !== undefined;
         isLegacy = selectedItem.is_legacy || hasLegacyId;
      } else {
         isLegacy = (String(this.$route.query.is_legacy) === 'true');
      }

      let route = isLegacy
        ? `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/videos/${this.trainingVideo.ID}/answers`
        : `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/modules/${this.trainingVideo.ID}/answers`;

      let data = { organisation_id: this.organisationID };

      if (isLegacy) {
        data.assigned_user_video_id = parseInt(legacy_assignment_id || this.assignedUserID);
      } else {
        data.user_assignment_id = parseInt(this.assignedUserID);
      }

      await this.$axios.post(route, data);
      await this.getLatestQuizAttempt(legacy_assignment_id);
    },

    async playerEnded() {
      const selectedItem = this.allModules.find(v => v.ID == this.assignedUserID || v.legacy_assigned_id == this.assignedUserID);

      let isLegacy = false;
      if (selectedItem) {
         const hasLegacyId = selectedItem.training_video && selectedItem.training_video.legacy_video_id !== null && selectedItem.training_video.legacy_video_id !== undefined;
         isLegacy = selectedItem.is_legacy || hasLegacyId;
      } else {
         isLegacy = (String(this.$route.query.is_legacy) === 'true');
      }

      if (this.currentTrainingType === 'scorm') {
        await this.updateVideoFinished(false);
        this.switching = true;
        this.$toast.success("SCORM Module completed successfully.");
        this.$router.push({ name: 'CompletedTraining' });
        return;
      }

      if (!isLegacy) {
        try {
          const userID = this.$store.state.auth.jwtPayload.user_id;
          const res = await this.$axios.get(`/trainings/users/${userID}/assignments/${this.assignedUserID}/modules/${this.trainingVideo.ID}/questions/total`);

          if (res.data.success && res.data.total > 0) {
             this.switching = true;
             await this.saveQuizAttempt(null);

             if (this.latestQuizAttempt) {
                 await this.$axios.put(`/trainings/users/${userID}/answers/${this.latestQuizAttempt.ID}?type=video_finished`, {});
             }

             this.$router.push({
               name: 'QuizTraining',
               params: { id: this.trainingVideo.ID },
               query: {
                 assigned: this.assignedUserID,
                 is_module: 'true',
                 rewatch: this.$route.query.rewatch // Pass the rewatch flag!
               }
             });
             return;
          }
        } catch (e) { console.warn("Failed to check module quiz", e); }
      }

      // If we reach here, it is either a Legacy Video (which always has a quiz)
      // OR a Custom Video with NO quiz.
      if (isLegacy) {
         this.switching = true;

         await this.updateVideoFinished(true);

         const quizAssignedId = (selectedItem && selectedItem.legacy_assigned_id) ? selectedItem.legacy_assigned_id : this.$route.query.assigned;

         this.$router.push({
           name: 'QuizTraining',
           params: { id: this.trainingVideo.ID },
           query: {
             assigned: quizAssignedId,
             is_legacy: 'true',
             rewatch: this.$route.query.rewatch
           }
         });
      } else {
         // Custom module with NO quiz -> Mark complete instantly!
         await this.updateVideoFinished(false);
         this.switching = true;
         this.$toast.success("Video completed!");
         this.$router.push({ name: 'CompletedTraining' });
      }
    },

    async getLatestQuizAttempt(legacy_assignment_id) {
      const fetchId = legacy_assignment_id || this.$route.query.assigned;

      const selectedItem = this.allModules.find(v => v.ID == this.assignedUserID || v.legacy_assigned_id == this.assignedUserID);
      let isLegacy = false;
      if (selectedItem) {
         const hasLegacyId = selectedItem.training_video && selectedItem.training_video.legacy_video_id !== null && selectedItem.training_video.legacy_video_id !== undefined;
         isLegacy = selectedItem.is_legacy || hasLegacyId;
      } else {
         isLegacy = (String(this.$route.query.is_legacy) === 'true');
      }

      let route = isLegacy
        ? `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/videos/${this.trainingVideo.ID}/answers/${fetchId}`
        : `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/modules/${this.trainingVideo.ID}/answers/${fetchId}`;

      return new Promise((resolve, reject) => {
        this.$axios.get(route)
        .then(response => {
          this.latestQuizAttempt = response.data.quiz_result;
          resolve(response.data.quiz_result);
        }).catch(error => reject(error))
      })
    },

    async getCaptionsByVideoID(id){
      return this.$axios.get(`/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/videos/${id}/captions`)
        .then((response) => {
          if (response.data.success){
            let tempData = []
            for (const caption of response.data.captions) {
                  let data = {
                    kind: "captions",
                    label: caption.label,
                    srclang: caption.source_lang,
                    src: caption.source_url,
                }
                tempData.push(data)
            }
            if (tempData.length == 0) this.playerOptions.tracks = null
            this.playerOptions.tracks = tempData
            return true
          }
          return false
        }).catch()
    },

    async checkAssignedID(id) {
      return this.trainingVideos.some(v => v.ID == id);
    },

    stringToBoolean(string) {
      switch(String(string).toLowerCase().trim()){
        case "true": case "yes": case "1": return true;
        case "false": case "no": case "0": case "null": return false;
        default: return Boolean(string);
      }
    },

    async updateVideoFinished(isLegacy) {
      let userID = this.$store.state.auth.jwtPayload.user_id;
      try {
        if (isLegacy) {
           if(!this.latestQuizAttempt) return;
           let data = { training_video_id: this.latestQuizAttempt.training_video_id };
           await this.$axios.put(`/trainings/users/${userID}/answers/${this.latestQuizAttempt.ID}?type=video_finished`, data);
        } else {
           await this.$axios.put(`/trainings/users/${userID}/assignments/${this.assignedUserID}/complete`);
        }
      } catch (error) {
        console.error("Failed to complete module", error);
      }
    },

    routeVideo(videoID, autoPlay, assignedID){
      this.$router.push({
        path: '/training/assigned-training',
        query: { watch: videoID, assigned: assignedID, autoplay: autoPlay }
      });
    },

    async getResizedImgSrc(imgSrc) {
      const response = await fetch(imgSrc);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        img.onload = () => {
          const canvas = this.$canvasResize(img, 150, 140);
          resolve(canvas.toDataURL());
        };
        img.onerror = error => reject(error);
      });
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (this.switching) { next(); return; }
    this.init();
    next();
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$store.state.auth.isSuperAdmin) {
        vm.$router.push({ name: 'UserLibrarySettings' });
      }
    })
  },

  computed: {
    videoAdded(){
      let videoAdded = ''

      if (this.$route.query.rewatch && this.$route.query.finished)
        return moment(this.$route.query.finished).local().format("LL")

      for (let index = 0; index < this.trainingVideos.length; index++) {
        const value = this.trainingVideos[index];
        if (value.training_video?.ID == this.trainingVideo.ID && value.ID == this.$route.query.assigned) {
          videoAdded = value.CreatedAt
        }
      }
      if (!videoAdded) return ""

      return moment(videoAdded).local().format("LL")
    },

    videoName() {
      return this.trainingVideo ? this.trainingVideo.name : ''
    },
  },
}
</script>

<style>
.videoContent {
  max-width: 1100px; /* Increased from 900px to make the player larger */
  width: 100%;
  margin: 0 auto;
}

.card-body-scroll { min-width: 300px; max-width: 200px; margin-right: 5px; }
.text-default{ color: #435666; }
.carousel__next{
   color: #ffffff; background:#00a0c1; margin-left:600px;
   right: 0px;
}
.carousel__prev{
  color: #ffffff; background:#00a0c1;
  left: 0px;
}
.carousel__icon { width:20px; height:20px; }
/* --- Navigation Arrows --- */
.player-nav {
  margin: auto;
  padding: 15px 50px; /* Creates 50px safe zones on the left and right for arrows */
}

.carousel__next {
   color: #ffffff;
   background: #00a0c1;
   right: 0px; /* Pins it to the right safe zone */
   position: absolute;
}

.carousel__prev {
  color: #ffffff;
  background: #00a0c1;
  left: 0px; /* Pins it to the left safe zone */
  position: absolute;
}

.carousel__icon { width: 24px; height: 24px; } /* Slightly larger arrows for better clicking */

@media only screen and (max-width: 600px) {
  .carousel__icon{ width: 18px; height: 18px; }
  .carousel__item { width: 30px; }
  .player-nav{ margin-top: 20%; padding: 10px 30px; } /* Smaller safe zones for mobile */
}

/* --- Card Wrapper --- */
.carousel-card-wrapper {
  position: relative;
  width: 85%; /* Reduced from 95% to make the thumbnails smaller */
  margin: 0 auto;
  aspect-ratio: 16 / 9; /* Perfect video thumbnail ratio */
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background-color: #f1f5f9;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Light up the border of the active center slide */
.carousel__slide--active .carousel-card-wrapper {
  border-color: #00a0c1;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media only screen and (max-width: 600px) {
  .carousel__icon{ width:50px; height:50px; }
  .carousel__item { width:30px; }
  .player-nav{ margin-top: 20%; }
}

.square { width: 80%; }
.carousel-card-wrapper {
  position: relative;
  width: 95%;
  margin: 0 auto;
  aspect-ratio: 16 / 9; /* Perfect video thumbnail ratio */
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background-color: #f1f5f9;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Light up the border of the active center slide */
.carousel__slide--active .carousel-card-wrapper {
  border-color: #00a0c1;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* --- Badges --- */
.type-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: white;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 5px;
  backdrop-filter: blur(4px);
}
.badge-video { background-color: rgba(30, 41, 59, 0.8); }
.badge-scorm { background-color: rgba(0, 160, 193, 0.9); }

/* --- Gradient Title Overlay --- */
.carousel-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 30px 12px 12px 12px;
  background: linear-gradient(to top, rgba(15, 23, 42, 0.9) 0%, rgba(15, 23, 42, 0) 100%);
  text-align: left;
}
.carousel-title {
  color: white;
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

/* Ensures the SCORM badge gets the teal brand color */
  .bg-theme {
    background-color: #00a0c1 !important;
  }
</style>